import React from 'react';
import {Container, Row, Col} from "reactstrap";
import {isUserAuthenticated} from "../services/auth";
import {Redirect} from "react-router-dom";
import Login from "../components/Login";
import RegisterV2 from "../components/RegisterV2";

const Auth = (props) => {
    if (isUserAuthenticated()) {
        return <Redirect to="/enrollment"/>
    }

    if (props.passwordResetToken) {
        return (
            <Redirect to={{
                pathname: "/reset-password",
                state: {
                    passwordResetToken: props.passwordResetToken,
                    passwordResetEmail: props.passwordResetEmail
                }
            }}/>
        );
    }

    return (
        <div className="page">
            <Container>
                <Row>
                    <Col md={{size: 6}}>
                        <RegisterV2/>
                    </Col>
                    <Col md={{size: 6}}>
                        <Login/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Auth;
